@if (cardInfo(); as info) {
  <div class="email-activity-wrapper">
    <crm-activity-card
      [activity]="info.activity"
      [icon]="isCampaign() || isYeswareCampaignEmail() ? EmailIcons.campaign : EmailIcons.default"
    >
      <!-- Activity title -->
      <span activity-title>
        <span class="title-type">{{ titleType() }}</span>
        <span class="title-text">{{ titleText() }}</span>
      </span>

      <!-- Activity subtitle -->
      <div activity-subtitle>
        @if (info.emailSubject && !isCampaign()) {
          <div class="email-subject">{{ info.emailSubject }}</div>
        }

        @if (isCampaign()) {
          <div class="campaign-info">
            <span class="campaign-display">
              <span>{{ info.emailSubject }}</span>
              {{ 'CONTACT.ACTIVITIES.CREATED_FROM' | translate }}
            </span>
            @if (!isDeletedCampaign()) {
              <span class="campaign-display bolded">
                <a href="{{ campaignLink() }}" target="_blank">{{ campaignName() }}</a>
              </span>
            } @else {
              <span class="campaign-display">{{ campaignName() }}</span>
            }
          </div>
        } @else if (isYeswareTrackedEmail() || isYeswareCampaignEmail()) {
          <div class="yesware-info">
            <span class="campaign-display">
              <span class="bolded">{{ info.emailSubject }}</span>
              @if (info.campaignName) {
                {{ 'CONTACT.ACTIVITIES.CREATED_FROM' | translate }}
                {{ info.campaignName }}
              }
            </span>
          </div>
        }
      </div>

      <!-- Activity preview -->
      <div activity-preview>
        @if (info.emailBody && !isCampaign()) {
          <crm-collapsible-section [maxHeightPx]="300">
            <div class="email-body" [innerHTML]="info.emailBody | iTrustThisHtml"></div>
          </crm-collapsible-section>
        }
      </div>
    </crm-activity-card>

    <!-- Related activities section -->
    @if (info.relatedActivities && info.relatedActivities.length > 0) {
      <div class="related-activities-section">
        <div class="show-activities" (click)="showRelatedActivities.set(!showRelatedActivities())">
          @if (showRelatedActivities()) {
            <mat-icon>unfold_less</mat-icon>
            {{ 'ACTIVITY.HIDE_RELATED_ACTIVITIES' | translate }}
          } @else {
            <mat-icon>unfold_more</mat-icon>
            {{ 'ACTIVITY.SHOW_RELATED_ACTIVITIES' | translate }}
          }
        </div>
        @if (showRelatedActivities()) {
          @for (activity of info.relatedActivities; track activity; let last = $last) {
            <div class="campaign-activity-card" [ngClass]="{ 'last-activity-card': last }">
              <mat-card class="campaign-inner-card">
                <mat-card-header [style.margin-left]="-(INNER_AVATAR_WIDTH / 2).toString() + 'px'">
                  @if (showAvatar) {
                    <div matCardAvatar>
                      <glxy-avatar
                        [width]="INNER_AVATAR_WIDTH"
                        icon="circle"
                        backgroundColor="var(--primary-background-color)"
                        textColor="var(--tertiary-text-color)"
                      ></glxy-avatar>
                    </div>
                  }
                  <mat-card-title>
                    <span class="title">{{ activity.emailStatus }}</span>
                  </mat-card-title>
                  <mat-card-subtitle>
                    <p class="effective-date">
                      {{ activity.effectiveDate | date: dateFormat }}
                    </p>
                  </mat-card-subtitle>
                </mat-card-header>
              </mat-card>
            </div>
          }
        }
      </div>
    }
  </div>
}
